import { GET_ALL_TAGS_SUCCESS } from '../actions/actionTypes';

export default function allTags(state = [], action) {
  switch (action.type) {
    case GET_ALL_TAGS_SUCCESS:
      return action.payload;
    default:
      return state;
  }
}
